/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cloneDeep, clone } from 'lodash';
import * as visahaulActions from '../actions/visahaulActions';
import * as studyActions from '../actions/studyActions';
import * as dictionaryActions from '../actions/dictionaryActions';
import * as crosstabActions from '../actions/crosstabActions';
import * as preferenceActions from '../actions/preferencesActions';
import { STORIES_RUN_REPORT, VISAHAUL_CONSTANT, STORIES_FEATUREID, PREFERENCE_STORIES,
  PREFERENCE_STUDY, PREFERENCE_STUDY_WEIGHTING, PAGE_VISIT_STORIES } from '../constants';
import { saveTrackingData, getLastUnsavedDetails } from '../util/trackerUtils';
import { setModuleDataOnSave } from '../util/preferenceUtils';
import StoriesSmartSearchEditor from '../components/stories/StoriesSmartSearchEditor';
import StoriesToolPalette from '../components/stories/StoriesToolPalette';
import { isFeaturePresent, getStudyFromStudies, filterStudyList } from '../util/CommonUtils';
import { toastWarning } from '../util/toastUtils';
import Modal from '../components/common/Modal/Modal';
import ValidateStudyModal from '../components/common/ValidateStudyModal';
import WarningIcon from './WarningIcon';

const validateModalStyle = {
  width: '50%',
  left: '30%',
  top: '12%',
};

class Stories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidData: {},
      hasStoriesStudies: props.hasStoriesStudies === undefined ?
      true : props.hasStoriesStudies,
    };
  }

  componentDidMount() {
    this.props.preferenceActions.setLastLocation({
      mainMenu: 'Essentials',
      mainModule: 'Stories',
    });
    const { latestStudies, userPreferences } = this.props;

    if (latestStudies && userPreferences && userPreferences._st
      && userPreferences._st._aus && Object.keys(latestStudies).length > 0
      && userPreferences._st._ds !== -1 && latestStudies._st.productNo
      !== userPreferences._st._ds) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, STORIES_FEATUREID),
        latestStudies._st.productNo);
      this.props.studyActions.updateModuleStudy(VISAHAUL_CONSTANT, selectedStudy);
      const userPreferences = cloneDeep(this.props.userPreferences);
      userPreferences._st._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);
      this.showNewStudyToastMessage(this.props.visahaulStudy, selectedStudy);
    }
    // this.handleWeightType();
    this.openLastSaveModal();
    const action = PAGE_VISIT_STORIES;
    this.callSaveTrackerFn({ action });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.hasStoriesStudies !== nextProps.hasStoriesStudies) {
      this.setState({ hasStoriesStudies: nextProps.hasStoriesStudies });
    }

    if (nextProps.userPreferences && nextProps.visahaulStudy
      && this.props.studies && nextProps.userPreferences[PREFERENCE_STORIES]
      && ((nextProps.visahaulStudy.pn !==
        nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY]) ||
        (nextProps.visahaulStudy.wt !==
          nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING]))
      && this.props.preferenceFlags[VISAHAUL_CONSTANT]) {
      let selectedStudy;
      const updatedWeightType = nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING] ===
        'Population' ? 1 : 2;
      if (nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY] !== -1) {
        selectedStudy = getStudyFromStudies(
          filterStudyList(this.props.studies, STORIES_FEATUREID),
          nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY]
        );
      } else {
        selectedStudy = this.props.studies[0].sl[0];
      }
      const hideWeightType = this.props.weightTypeStudies &&
        this.props.weightTypeStudies.some(el => {
          return el.pn === selectedStudy.pn;
        });
      this.setState(() => ({ hideWeightType }));
      selectedStudy = {
        ...selectedStudy,
        wt: updatedWeightType,
      };
      if (selectedStudy !== undefined) {
        this.props.studyActions.updateModuleStudy('visahaul', selectedStudy);
        const updatedWeightTypeObj = (typeof
          (nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING]) ===
          'string' || nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING].wt ===
          undefined) ? selectedStudy.cw[0] : nextProps.userPreferences[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING];
        this.props.studyActions.updateWeightType('stories', updatedWeightTypeObj);
      }
      this.props.preferenceActions.setPreferenceFlag(VISAHAUL_CONSTANT, false);
    }
    if (nextProps.visahaulStudy && this.props.visahaulStudy !== nextProps.visahaulStudy) {
      this.setState({ invalidData: {} });
      if (this.props.visahaul && this.props.visahaul.length > 0) {
        this.studyChangeValidate(this.props, nextProps);
      }
    }
    if (nextProps.latestStudies
      && nextProps.userPreferences && nextProps.userPreferences._st
      && nextProps.userPreferences._st._aus
      && this.props.latestStudies !== nextProps.latestStudies
      && Object.keys(nextProps.latestStudies).length > 0
      && nextProps.userPreferences._st._ds !== -1
      && nextProps.latestStudies._st.productNo !== nextProps.userPreferences._st._ds) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, STORIES_FEATUREID),
        nextProps.latestStudies._st.productNo
      );
      this.props.studyActions.updateModuleStudy(VISAHAUL_CONSTANT, selectedStudy);
      this.showNewStudyToastMessage(nextProps.visahaulStudy, selectedStudy);
      const userPreferences = cloneDeep(nextProps.userPreferences);
      userPreferences._st._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);
    }
    if (nextProps.visahaul && this.props.visahaul &&
      nextProps.visahaul !== this.props.visahaul && this.props.visahaul.length > 0) {
      const colExpressionList = [];
      colExpressionList.push(this.props.visahaul[0].keyword);
      const colHeaderList = [];
      colHeaderList.push(this.props.visahaul[0].title);
      const colOriginalHeaderList = [];
      colOriginalHeaderList.push(this.props.visahaul[0].originalTitle);
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: nextProps.visahaulStudy.pn,
        weightType: nextProps.storiesWeightTypes.wt,
        divisor: nextProps.storiesWeightTypes.dv,
        baseList: [],
        baseHeaderList: [],
        baseOriginalHeaderList: [],
        colExpressionList,
        colHeaderList,
        colOriginalHeaderList,
        rowExpressionList: [],
        rowHeaderList: [],
        rowOriginalHeaderList: [],
      };
      this.props.crosstabActions.validateCRB(validateParams);
    }
    if (
      nextProps.gridsValidationResponse &&
      this.props.gridsValidationResponse !== nextProps.gridsValidationResponse
    ) {
      this.handleGridValidationResponse(nextProps.gridsValidationResponse);
      // this.setState({ gridsValidationResponseOriginal: nextProps.gridsValidationResponse });
    }
  }

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    RecycleElements: this.props.recycleElements,
    TargetDataGridData: this.props.visahaul,
  });

  getCrosstabOrTrendParams = () => {
    const { crosstabActions, loginResponse, activeAccountId, visahaulStudy, visahaul } = this.props;
    crosstabActions.addDDNHCSData([]);
    const ddNHCSReportsList = [];
    crosstabActions.addDDNHCSData(ddNHCSReportsList);
    return {
      token: loginResponse.data.token,
      accountId: activeAccountId,
      uid: loginResponse.data.uid,
      weightType: this.props.storiesWeightTypes.wt,
      divisor: this.props.storiesWeightTypes.dv,
      selectedWeightName: this.props.storiesWeightTypes.wn,
      productNo: visahaulStudy.pn,
      targetExpression: visahaul[0].keyword,
      targetLabel: visahaul[0].title,

    };
  };

  saveUserPreference = (preferences, moduleUpdateFlag) => {
    const clonedPreferences = clone(preferences);
    this.props.preferenceActions.saveUserPreferences(
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      preferences
    ).then(response => {
      if (response && moduleUpdateFlag) {
        this.props.setModuleDataOnSave(clonedPreferences);
      }
    });
  }

  studyChangeValidate = (props, nextProps) => {
    const colExpressionList = [];
    const colHeaderList = [];
    const colOriginalHeaderList = [];
    const productNo = nextProps.visahaulStudy.pn;
    const weightType = nextProps.storiesWeightTypes.wt;
    const divisor = nextProps.storiesWeightTypes.dv;
    if (props.visahaul) {
      props.visahaul.map(item => {
        colExpressionList.push(item.keyword);
        colHeaderList.push(item.title);
        colOriginalHeaderList.push(item.originalTitle);
        return item;
      });
    }
    const validateParams = {
      token: props.loginResponse.data.token,
      uid: props.loginResponse.data.uid,
      accountId: props.activeAccountId,
      productNo,
      weightType,
      divisor,
      colExpressionList,
      colHeaderList,
      colOriginalHeaderList,
    };
    this.props.crosstabActions.validateCRB(validateParams);
  };

  handleGridValidationResponse = gridsValidationResponse => {
    let smartSearchColumns = {};
    smartSearchColumns = this.props.visahaul
      ? this.props.visahaul.reduce(
        (acc, val) => ({
          ...acc,
          [val.keyword]: val.dataSmartSearch,
        }),
        {},
      )
      : {};

    if (!gridsValidationResponse.colList[0].valid) {
      this.props.crosstabActions.clearSampleWeighted('VisaTargetDataGrid');
    }

    this.props.crosstabActions.removeCrosstabData('gridsValidationResponse');
    const invalidData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
    };
    const validData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
    };
    gridsValidationResponse.colList.map((node, index) => {
      const colName = node.label;
      if (node.valid) {
        validData.columnsGrid.selectedKeywords.push(node.expression);
        validData.columnsGrid.selectedNames.push(colName);
        validData.columnsGrid.originalNames.push(
          gridsValidationResponse.colOriginalHeaderList[index],
        );
        if (validData.columnsGrid.dataSmartSearch) {
          validData.columnsGrid.dataSmartSearch.push(
            smartSearchColumns[node.expression],
          );
        }
      } else {
        invalidData.columnsGrid.selectedKeywords.push(node.expression);
        invalidData.columnsGrid.selectedNames.push(colName);
        invalidData.columnsGrid.originalNames.push(
          gridsValidationResponse.colOriginalHeaderList[index],
        );
      }
      return null;
    });

    if (
      invalidData.columnsGrid.selectedKeywords.length > 0
    ) {
      this.setState({ invalidData }, () => { this.validateStudyModal.show(); });
    }

    let sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.visahaulStudy.pn,
      weightType: this.props.storiesWeightTypes.wt,
      divisor: this.props.storiesWeightTypes.dv,
    };

    if (validData.columnsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: validData.columnsGrid.selectedKeywords,
        selectedNames: validData.columnsGrid.selectedNames,
        originalNames: validData.columnsGrid.originalNames,
        objSmartSearchArray: validData.columnsGrid.dataSmartSearch,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.columnsGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else {
      this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    }
  };

  handleWeightType = () => {
    let hideWeightType;
    if (this.props.visahaulStudy) {
      hideWeightType = this.props.weightTypeStudies.some(el => {
        return el.pn === this.props.visahaulStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
    }
  }

  openLastSaveModal = () => {
    const currentModule = VISAHAUL_CONSTANT;
    if (this.props.loginResponse) {
      this.props.getLastUnsavedDetails(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        currentModule,
      );
    }
  }

  callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const productNo = this.props.visahaulStudy !== undefined ?
      this.props.visahaulStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: VISAHAUL_CONSTANT,
      attributes,
      action,
    });
  }

  showNewStudyToastMessage = (beforeUpdateStudy, afterUpdateStudy) => {
    toastWarning(
      <span style={{ color: 'black', width: '400px' }}>
        Your default study has been updated from
        <span style={{ fontWeight: 'bold' }}> {beforeUpdateStudy.sd} </span>
        to <span style={{ fontWeight: 'bold' }}> {afterUpdateStudy.sd}. </span>
        This change is occuring because you have previously set your preferences to
         automatically update your study on start-up when a
         new version of the study type is released.
      </span>);
  }

  handleStudyChange = (val, updatedWeightType) => {  // weight type needs to be sent from study selector
    const { crosstabActions, studyActions, dictionaryActions } = this.props;
    crosstabActions.addDDNHCSData([]);
    crosstabActions.clearSampleWeightedKPIs();
    const updatedStudy = {
      ...val,
      wt: 1,   // updating weight type to population by default.
    };
    studyActions.updateModuleStudy(VISAHAUL_CONSTANT.toLowerCase(), updatedStudy, updatedWeightType);
    // const hideWeightType = weightTypeStudies.some(el => {
    //   return el.pn === updatedStudy.pn;
    // });
    // this.setState(() => ({ hideWeightType }));
    dictionaryActions.clearTreeLoadNodeList();
  }

  callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const { loginResponse, activeAccountId, visahaulStudy } = this.props;
    const productNo = visahaulStudy !== undefined ?
      visahaulStudy.pn : undefined;
    saveTrackingData({
      uid: loginResponse.data.uid,
      accid: activeAccountId,
      productNo,
      moduleName: VISAHAUL_CONSTANT,
      attributes,
      action,
    });
  }

  handleCrosstabEdit = (idKey, dataSmartSearch) => {
    if (dataSmartSearch) {
      if (this.smartSearchEditor) {
        this.smartSearchEditor.handleCrosstabEdit(idKey, dataSmartSearch);
      }
    }
  };

  handleVisaHaulEdit = (idKey, dataSmartSearch, keyword) =>
    this.handleCrosstabEdit(idKey, dataSmartSearch, keyword);

  runVisaHaul = () => {
    this.callSaveTrackerFn({ action: STORIES_RUN_REPORT });
    const params = this.getCrosstabOrTrendParams(VISAHAUL_CONSTANT);
    this.props.visahaulActions.downloadVisaReport(params);
  };

  render() {
    const { modulePermissions } = this.props;
    if (isFeaturePresent(STORIES_FEATUREID, modulePermissions)) {
      if (!this.state.hasStoriesStudies) {
        return (
          <div className="no-study-message">
            <WarningIcon />
            <p>
              You do not currently have studies to the Stories application.
              Please contact your Account Manager to learn more about your studies.
            </p>
          </div>
        );
      }
      return (
        <div>
          <input
            type="checkbox"
            className="sidebar-left"
            id="sidebar-left-01"
            onChange={this.handlesideBarToggle}
            checked={this.state.sideBarChecked}
          />
          <label className="sidebar-left" htmlFor="sidebar-left-01" />
          <StoriesToolPalette
            visaTarget={this.props.visahaul}
            getCrosstabTitle={this.getCrosstabTitle}
            handleCrosstabEdit={this.handleVisaHaulEdit}
            dataScreen={VISAHAUL_CONSTANT}
            resetSmarchSearch={this.resetSmarchSearch}
            runCrosstab={this.runCrosstabOrTrend}
            handleSaveCrosstab={this.handleSaveCrosstab}
            resetTitle={this.resetTitle}
            shareCrosstab={this.shareCrosstabIcon}
          />
          <div className="width-80 portfolio-crosstab float-left portfolio-crosstab-height">
            <div className="crosstab-accordion">
              <StoriesSmartSearchEditor
                visahaulStudy={this.props.visahaulStudy}
                getSampleWeighted={this.props.crosstabActions.getSampleWeighted}
                fetchKPI={this.props.crosstabActions.fetchKPI}
                gridData={this.getGridData()}
                cellElementList={this.state.cellElementList}
                runVisaHaul={this.runVisaHaul}
                dataScreen={VISAHAUL_CONSTANT}
                trackerFn={this.callSaveTrackerFn}
                isSmartSearchSelected
                handleStudyChange={this.handleStudyChange}
                hideWeightType={this.state.hideWeightType}
                ref={node => {
                  this.smartSearchEditor = node;
                  return this.smartSearchEditor
                }}
              />
            </div>
          </div>
          <Modal
            title="Validate Study Results"
            ref={node => {
              this.validateStudyModal = node;
              return this.validateStudyModal;
            }}
            dialogStyles={validateModalStyle}
          >
            <div>
              <ValidateStudyModal
                handleParentHide={() => this.validateStudyModal.hide()}
                moduleStudy={this.props.visahaulStudy}
                invalidData={this.state.invalidData}
                dataScreen={VISAHAUL_CONSTANT}
              />
            </div>
          </Modal>
        </div>
      );
    }
    return (<div className="coming-soon">{'Sorry, You don\'t have enough permission to view this page.'}</div>);
  }
}

Stories.propTypes = {
  visahaul: PropTypes.arrayOf(PropTypes.object),
  visahaulActions: PropTypes.shape({
    downloadVisaReport: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    fetchKPI: PropTypes.func,
    validateCRB: PropTypes.func,
    getSampleWeightedData: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    removeCrosstabData: PropTypes.func,
    addDDNHCSData: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
  }),
  visahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
    clearTrendStudies: PropTypes.func,
    updateWeightType: PropTypes.func,
  }),
  // weightTypeStudies: PropTypes.arrayOf(PropTypes.object),
  dictionaryActions: PropTypes.shape({
    clearTreeLoadNodeList: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  kpiInfo: PropTypes.shape({}),
  modulePermissions: PropTypes.instanceOf(Array),
  studies: PropTypes.arrayOf(PropTypes.object),
  preferenceActions: PropTypes.shape({
    setPreferenceFlag: PropTypes.func,
    setLastLocation: PropTypes.func,
    saveUserPreferences: PropTypes.func,
  }),
  preferenceFlags: PropTypes.shape({}),
  latestStudies: PropTypes.shape({
    _st: PropTypes.shape({
      productNo: PropTypes.number,
    }),
  }),
  userPreferences: PropTypes.shape({
    _st: PropTypes.shape({
      productNo: PropTypes.number,
      _aus: PropTypes.bool,
      _ds: PropTypes.number,
    }),
  }),
  getLastUnsavedDetails: PropTypes.func,
  setModuleDataOnSave: PropTypes.func,
  hasStoriesStudies: PropTypes.bool,
  gridsValidationResponse: PropTypes.shape({}),
  sampleWeightedKPIs: PropTypes.shape({}),
  storiesWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
  weightTypeStudies: PropTypes.instanceOf(Array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    visahaul: state.crosstab.VisaTargetDataGridData,
    recycleElements: state.crosstab.RecycleGridData,
    kpiInfo: state.crosstab.kpiInfo,
    visahaulStudy: state.study.visahaulStudy,
    // weightTypeStudies: state.study.weightTypeStudies,
    modulePermissions: state.userDetail.permissions,
    studies: state.study.studies,
    preferenceFlags: state.preferences.preferenceFlags,
    userPreferences: state.preferences.userPreferences,
    latestStudies: state.study.latestStudies,
    lastLocation: state.preferences.lastLocation,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    gridsValidationResponse: state.crosstab.gridsValidationResponse,
    hasStoriesStudies: state.study.hasStoriesStudies,
    storiesWeightTypes: state.study.storiesWeightTypes,
    // definition: state.definitionTree.data, // added for testing infinite loop, should be removed
  };
}

function mapDispatchToProps(dispatch) {
  return {
    visahaulActions: bindActionCreators(visahaulActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
    setModuleDataOnSave: bindActionCreators(setModuleDataOnSave, dispatch),
    getLastUnsavedDetails: bindActionCreators(getLastUnsavedDetails, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Stories);
